var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeCleaningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eccb7c5f-f0cf-4303-8bd1-a37c4536205d",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 139.56 139.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M93.94,25.2l-11.31,8H65L61.9,29.7A8,8,0,0,0,56,27.09H48.15V20.24a4,4,0,0,1,4-4H86Z",
    style: {
      fill: "#695f69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,33.15h17.6v8.26H65Z",
    style: {
      fill: "#fcdd2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.94,115.11H42.46v-2.93A122.19,122.19,0,0,1,65,41.41h17.6l4.57,3.2a15.86,15.86,0,0,1,6.74,13Z",
    style: {
      fill: "#e14c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.62,115c.88-26.26,7.5-51.71,19.14-73.63H87.92l2.57,2.24a11,11,0,0,1,3.45,8.27V115Z",
    style: {
      fill: "#d14040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.69,20.64h6.46v6.45H41.69Z",
    style: {
      fill: "#d14040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.15,27.09v6.06l-4.4,8.26h5.86l5.76-8.26V27.09Z",
    style: {
      fill: "#fcdd2e"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCleaningIcon);
export default __webpack_public_path__ + "static/media/home-cleaning-icon.6bf15cf3d09abbd256490d83c3e2a79d.svg";
export { ForwardRef as ReactComponent };